import type { AxiosError, AxiosResponse } from 'axios';
import { checkNetworkAvailability } from '../../containers/CheckAppAvailable/helpers';
import { handleUnauthorizedResponse } from '../../containers/Organizations/OrganizationsSlice/unauthorizedHandler';
import { store } from '../../store';

export const handleLegacyApiResponse = (response: AxiosResponse) => {
  if (response.data) {
    return response.data;
  }
  return response;
};

export const handleLegacyApiError = (
  error: AxiosError,
  returnErrorResponseData?: boolean
): void => {
  if (error.response?.status === 401 && error.response?.data === 'Invalid CSRF') {
    checkNetworkAvailability();
  }

  if (error.response?.status === 500 || error.response?.status === 404) {
    checkNetworkAvailability();
  }

  if (!error.response && error.request) {
    checkNetworkAvailability();
  }

  if (
    error.response?.status === 401 &&
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ['unauthorized-access', 'invalid-session'].includes(error.response?.data?.Code)
  ) {
    // Same multi-org behaviour as the Core client: keeps other cached tenants
    // alive when only one organisation's session expires.
    store.dispatch(handleUnauthorizedResponse());
  }

  if (returnErrorResponseData && error.response?.data) {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw error.response?.data;
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (error.response?.data.Message || error.message) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    throw error.response?.data.Message || error.message;
  }

  throw error;
};
